<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <validation-observer ref="userImportValidator">
          <v-form>
            <v-card class="layout-custom-import rounded-card" elevation="1">
              <v-card-title>
                ユーザ情報のインポート
              </v-card-title>
              <v-card-subtitle>
                <p>ここでは指定する形式のCSVでインポートすることでユーザ情報を一括登録することができます。</p>
              </v-card-subtitle>
              <v-divider />
              <v-card-text>
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: true, mimes: 'text/csv', megaFileSizeChecker: 10, fileChecker: true }"
                  class="requiredMark"
                  name="CSVファイル"
                >
                  <v-file-input
                    v-model="forms.file"
                    :error-messages="errors"
                    :show-size="1000"
                    accept="text/csv"
                    dense
                    hide-details="auto"
                    hint="ファイルサイズ10MBまで。最大3000件まで。"
                    label="CSVファイル"
                    outlined
                    persistent-hint
                    persistent-placeholder
                    required
                  />
                </validation-provider>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  @click="uploadButtonClickEvent"
                >
                  アップロード
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </validation-observer>
      </v-col>
    </v-row>
    <csv-import-result import-type="user" :do-reload="reloadComponent" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import CsvImportResult from '../../../components/_CsvImportResults'

export default {
  name: 'UserCsvImport',
  components: {
    CsvImportResult,
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: 'ユーザ一覧', disabled: false, to: '/driver/masters/users', exact: true },
        { text: 'ユーザ情報のインポート', disabled: true, to: '' },
      ],
      forms: {
        file: null,
      },
      reloadComponent: null,
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    ...mapActions('DriverSettingUser', {
      upload: 'create',
    }),
    uploadButtonClickEvent () {
      let $self = this
      this.$refs.userImportValidator.validate().then((result) =>{
        if(result){
          $self.sendRegistrationInformation()
        }
      })
    },

    sendRegistrationInformation(){
      const params = new FormData()
      params.append('file', this.forms.file)
      /**
       * @typedef content { Object }
       * @property has_error { Boolean }
       * @property errors { Array }
       */
      this.upload({params: params}).then(() => {
        this.reloadComponent = this.$dayjs().unix()
        this.resetForm()
      })
    },
    resetForm () {
      this.$nextTick(() => this.$refs.userImportValidator.reset())
      Object.assign(this.$data.forms, this.$options.data().forms)
    },
  }
}
</script>

<style scoped lang="scss">

</style>
